export default __webpack_public_path__ + "static/media/_DSC0784.0f5320e7.JPG";